export const shareWithWorkspaceChecked = (sharingSettings: any): boolean => {
  return (
    sharingSettings.shared_with_workspace.edit ||
    sharingSettings.shared_with_workspace.view ||
    false
  );
}

export const getShareWithWorkspaceOption = (sharingSettings: any): string => {
  return sharingSettings.shared_with_workspace.edit ? 'edit' : 'view';
}
